// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__aia2g","rotate":"styles_rotate__x24AV","center":"styles_center__+CHpa","stretch":"styles_stretch__pp371"};